<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div class="border-4 border-dashed border-gray-200 bg-white overflow-hidden shadow-lg rounded-lg h-48">
  </div>
</template>

<script>
export default { }
</script>
